module.exports = __webpack_public_path__ + "static/media/more-sharing.01068da4.svg";